import { Unsubscribe } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { useAppSelector } from '@core/hooks/appHooks';
import { NetworkService } from '@core/services/networkService/networkService';
import { RoutingViews, routingPaths } from '@core/services/routingService';
import { selectVendor } from '@core/store/appSlice/appSlice';
import DemmiButton, { DemmiButtonSize } from '@demmi-ui/Button';
import { navigateTransitioned } from '@helpers/app.helper';
import { DemmiFS } from '@subhanhabib/demmilib';

import DashboardSection from '../DashboardSection';
import WidgetOrderItem from './WidgetOrderItem';

const WidgetOrders: React.FC = () => {
  const CSSBlock = 'widget-orders';

  const navigate = useNavigate();
  const vendor = useAppSelector(selectVendor);
  const [isLoading, setIsLoading] = useState(true);
  const [orders, setOrders] = useState<DemmiFS.Order[]>([]);

  useEffect(() => {
    let snapshotListener: Unsubscribe | undefined;
    if (vendor) {
      const ordersCallback = (o: DemmiFS.Order[]) => {
        const incomingOrders = DemmiFS.OrderHelper.getIncomingOrders(
          vendor.docID,
          o,
        );
        setOrders(DemmiFS.OrderHelper.sortByCollectionDate(incomingOrders));
        setIsLoading(false);
      };
      NetworkService.Orders.listenToOrders(vendor.docID, ordersCallback).then(
        u => (snapshotListener = u),
      );
    }

    return () => {
      if (snapshotListener) snapshotListener();
    };
  }, [vendor]);

  return (
    <DashboardSection
      className={CSSBlock}
      isLoading={isLoading}
      title="Incoming Orders"
      titleButton={
        <DemmiButton
          text="View All"
          size={DemmiButtonSize.S}
          onClick={() => {
            navigateTransitioned({
              navigate,
              to: routingPaths[RoutingViews.ORDERS_INCOMING],
            });
          }}
        />
      }>
      <div className={`${CSSBlock}__list`}>
        {orders.length > 0
          ? orders.map((order, i) => <WidgetOrderItem order={order} key={i} />)
          : isLoading === false && (
              <div style={{ textAlign: 'center', margin: '4rem auto' }}>
                No orders
              </div>
            )}
      </div>
    </DashboardSection>
  );
};

export default WidgetOrders;
